import { Component, OnInit } from '@angular/core';
import {HeaderFilterService} from '@Common/widgets/general/data-table/services/header-filter.service';
import {DataTableHeaderCommunicationService} from '@Common/widgets/general/data-table';
import {DepositService} from '../../../services/deposit/deposit.service';
import {UntypedFormControl} from '@angular/forms';
import {DepositConservation} from '../../../services/deposit/deposit.model';
import {MatSelectChange} from '@angular/material/select';
import {FilterConservationDepositsData} from './filter-conservation-deposits.model';

@Component({
  selector: 'app-filter-conservation-deposits',
  templateUrl: './filter-conservation-deposits.component.html',
  styleUrls: ['./filter-conservation-deposits.component.scss', '../filter-deposits.component.scss']
})
export class FilterConservationDepositsComponent extends HeaderFilterService implements OnInit {
  conservationControl = new UntypedFormControl([]);
  conservations: DepositConservation[] = [DepositConservation.PARTIAL, DepositConservation.INTEGRAL,
    DepositConservation.ELIMINATE, DepositConservation.SCAN];
  conservationDefault: DepositConservation;
  constructor(public dtCommunicationSvc: DataTableHeaderCommunicationService,
              public depositSvc: DepositService) {
    super(dtCommunicationSvc);
  }

  ngOnInit(): void {
    this._setConservation();
  }
  onSelected(event: MatSelectChange) {
    this.conservationDefault = event.value;
  }
  onCancel(event) {
  }

  onValidate(event) {
    const dataEmit = <FilterConservationDepositsData> {
      nameComponent: this.name,
      action: 'validate',
      value: this.conservationDefault,
      condition: this.conservationDefault ? `sur ${this.depositSvc.displayConservationByType(this.conservationDefault)}` : ''
    };
    this.subject.next(dataEmit);
    this.dtCommunicationSvc.filterUsed(this.name, dataEmit);
  }

  sendAllReinit(reinit: boolean) {
    this._sendReinit();
  }

  sendReinit(filterName: string) {
    this._sendReinit();
  }
  private _sendReinit() {
    this.conservationDefault = null;
    const dataEmit = <FilterConservationDepositsData>{nameComponent: this.name, action: 'reinit'};
    this.subject.next(dataEmit);
    this.dtCommunicationSvc.filterUsed(this.name, dataEmit, false);
  }
  /**
   * Positionne le type de conservation si déjà filtré sur ce dernier (this.data)
   * @private
   */
  private _setConservation() {
    if (this.data) {
      this.conservationDefault = this.conservations.find(_state => _state === (<DepositConservation> this.data)) || null;
      if (this.conservationDefault) {
        this.conservationControl.patchValue(this.conservationDefault);
      }
    }
  }
}
